export const pluralize = (singular, plural, count) => {
    return count === 1 ? singular : plural;
}

export const getShortenedText = (text, maxLength) =>
    text.length > maxLength
        ? text.substring(0, maxLength - 3) + '...'
        : text;
